export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"「115年全民親山步道票選活動」邀請全民一起走進山林、票選心中最喜愛的臺灣步道！精選全臺北、中、南、東20條特色步道，結合步道票選、主題形象蓋章，一起認識臺灣步道之美，支持喜愛的步道，還有機會參加抽獎、把好禮帶回家！"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"115年全民親山步道票選活動"},{"property":"og:title","content":"115年全民親山步道票選活動"},{"property":"og:description","content":"「115年全民親山步道票選活動」邀請全民一起走進山林、票選心中最喜愛的臺灣步道！精選全臺北、中、南、東20條特色步道，結合步道票選、主題形象蓋章，一起認識臺灣步道之美，支持喜愛的步道，還有機會參加抽獎、把好禮帶回家！"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/logo.ico"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700;900&display=swap"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"zh-Hant"},"title":"115年全民親山步道票選活動"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true